import React, { useEffect, useState } from 'react'
import { Box, Typography, Button, Snackbar } from '@mui/material'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied'
const Error500 = () => {
  const [openSnackbar, setOpenSnackbar] = useState(true)

  useEffect(() => {
    // const timer = setTimeout(() => {
    //   window.location.href = '/' // Перенаправление на главную страницу
    // }, 3000)
    //
    // return () => clearTimeout(timer) // Очистка таймера при размонтировании
  }, [])

  const handleReload = () => {
    window.location.href = '/' // Перенаправление на главную страницу
  }

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        textAlign: 'center',
      }}
    >
      <Typography variant="h1" sx={{ fontSize: '5rem', color: '#f44336' }}>
        404
      </Typography>
      <Typography
        variant="h5"
        sx={{ marginBottom: '20px', display: 'flex', alignItems: 'center' }}
      >
        Страница не найдена <SentimentVeryDissatisfiedIcon />
      </Typography>
      <Typography variant="body1" sx={{ marginBottom: '30px' }}>
        Вы будете перенаправлены на главную страницу
      </Typography>
      <Button variant="contained" color="primary" onClick={handleReload}>
        На гланвую
      </Button>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        message="Скоро вы будете перенаправлены на главную страницу"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      />
    </Box>
  )
}

export default Error500
